import script from "./PanelAddResult.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelAddResult.vue?vue&type=script&setup=true&lang=js"

import "./PanelAddResult.vue?vue&type=style&index=0&id=0dceabcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dceabcc"]])

export default __exports__